import { IoIosNotifications } from "react-icons/io";

export default function DummyBanner() {
  return (
    <div className="position-fixed bottom-0 start-0 alert alert-warning alert-dismissible fade show m-2" role="alert" style={{ zIndex: '9999'}} >
      <div className="d-flex align-items-center">
        <div className="flex-shrink-0">
          <IoIosNotifications className="me-2" style={{ fontSize: '1.25rem' }} />
        </div>
        <div>
          <p className="mb-0 fw-medium">
            ⚠️ This page is temporary and contains dummy data. Development in progress.
          </p>
        </div>
      </div>
    </div>
  );
}